import { render, staticRenderFns } from "./card-open.vue?vue&type=template&id=5d2d6d7c&scoped=true"
import script from "./card-open.vue?vue&type=script&lang=ts"
export * from "./card-open.vue?vue&type=script&lang=ts"
import style0 from "./card-open.vue?vue&type=style&index=0&id=5d2d6d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d6d7c",
  null
  
)

export default component.exports